export default (props = {}) => <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.39209 4.30163L8.92651 0.767212L10.3921 2.23279L5.39209 7.23279L0.39209 2.23279L1.85767 0.767212L5.39209 4.30163Z" fill="#0057B8"/>
</svg>
